import { Container } from './components/Container';
import { ButtonsBar } from './components/ButtonsBar';
//@ts-ignore
import React, { FC } from 'react';
import FullScreen from './components/FullScreen';
import { PopupProps } from './types';
import { Res } from '../types';

const Popup: FC<PopupProps & { children?: any }> = ({ show, onClose, settings, children }) => {
  if (!show) return null;
  const { width, height, resolution } = settings;
  const unit = resolution === Res.Pixels ? 'px' : resolution === Res.Percentage ? '%' : 'vw';
  const widthIsAlmostFullscreen = resolution === Res.Percentage && width > 95;
  return (
    <div
      style={{
        position: 'fixed',
        height: width === 75 && resolution === Res.Percentage ? 'calc(100vh - 48px)' : '100vh',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 155,
      }}
    >
      <Container width={`${width}${unit}`} height={`${height}${unit}`}>
        <FullScreen attrs={{ id: 'popup-container' }}>
          {({ isFullScreen, toggleFullscreen }: any) => (
            <>
              <ButtonsBar
                isFullScreen={isFullScreen || widthIsAlmostFullscreen}
                toggleFullscreen={toggleFullscreen}
                closePopup={onClose}
              />
              <div style={{ width: '100%', height: '100%' }}>{children}</div>
            </>
          )}
        </FullScreen>
      </Container>
    </div>
  );
};

export default Popup;
